export const definitions = [
  {
    columns: [
      {
        isMain: true,
        content: 'Consent',
      },
      {
        content:
          'the consent of the Data Subjects which must be a freely given, specific, informed, and unambiguous indication of the Data Subjects’ wishes by which they, by a statement or by a clear affirmative action, signify their agreement to the Processing of Personal Data relating to them;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Data Controller',
      },
      {
        content:
          'the natural or legal person or organisation which, alone or jointly with others, determines the purposes and means of the Processing of Personal Data;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Data Processor',
      },
      {
        content:
          'a natural or legal person or organisation which Processes Personal Data on behalf of a Data Controller;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Data Protection Contact',
      },
      {
        content:
          "the person responsible for administering this Data Policy and for developing and implementing any applicable related policies, procedures, and/or guidelines. Enroly's Data Protection Contact is Mike Stone\n" +
          'Email: mike@enroly.com\n' +
          'Phone: +44(0)7898 875492',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Data Protection Law',
      },
      {
        content:
          'the EU Regulation 2016/679 General Data Protection Regulation (“GDPR”);\n' +
          'the Data Protection Act 2018; and\n' +
          'any successor legislation or other directly applicable EU regulation relating to data protection and data privacy for as long as, and to the extent that, EU law has legal effect in the UK.',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Data Subject',
      },
      {
        content:
          'means a living, identified, or identifiable natural person about whom Enroly holds Personal Data. To the extent Enroly holds their Personal Data, the Students shall be considered Data Subjects for the purposes of this Data Policy;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'EEA',
      },
      {
        content:
          'means the European Economic Area, consisting of all EU Member States, Iceland, Liechtenstein, and Norway;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Personal Data',
      },
      {
        content:
          'any information relating to a Data Subject who can be identified, directly or indirectly, in particular by reference to an identifier such as a name, identification number, location data, an online identifier, or to one or more factors specific to the physical, physiological, genetic, mental, economic, cultural, or social identity of that Data Subject;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Personal Data Breach',
      },
      {
        content:
          'a breach of security leading to the accidental or unlawful destruction, loss, alteration, unauthorised disclosure of, or access to, Personal Data transmitted, stored, or otherwise Processed;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Processing',
      },
      {
        content:
          'means any operation or set of operations performed on Personal Data or sets of Personal Data, whether or not by automated means, such as collection, recording, organisation, structuring, storage, adaptation or alteration, retrieval, consultation, use, disclosure by transmission, dissemination or otherwise making available, alignment or combination, restriction, erasure or destruction;',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Pseudonymisation',
      },
      {
        content:
          'the Processing of Personal Data in such a manner that the Personal Data can no longer be attributed to a specific Data Subject without the use of additional information, provided that such additional information is kept separately and is subject to technical and organisational measures to ensure that the Personal Data is not attributed to an identified or identifiable natural person; and',
      },
    ],
  },
  {
    columns: [
      {
        isMain: true,
        content: 'Sensitive Personal Data',
      },
      {
        content:
          'Personal Data revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, trade union membership, health, sexual life, sexual orientation, biometric, or genetic data.',
      },
    ],
  },
];

export const purposes = [
  {
    columns: [
      {
        isHeader: true,
        content: 'Type of Data',
      },
      {
        isHeader: true,
        content: 'Purpose of Data',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student name',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student date of birth',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student nationality',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student race or ethnic origin',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Information about a Student’s background',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student Academic history',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student Financial standing',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student Contact information',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student’s Dependants',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
  {
    columns: [
      {
        content: 'Student Visa & Travel History',
      },
      {
        content: 'To provide You with information to make admission and visa based decisions',
      },
    ],
  },
];

export const dataRetentionPolicy = [
  {
    columns: [
      {
        isHeader: true,
        content: 'Type of data',
      },
      {
        isHeader: true,
        content: 'Type of data subject',
      },
      {
        isHeader: true,
        content: 'Type of processing',
      },
      {
        isHeader: true,
        content: 'Purpose of processing',
      },
      {
        isHeader: true,
        content: 'Type of recipient to whom personal data is transferred',
      },
      {
        isHeader: true,
        content: 'Retention period',
      },
      {
        isHeader: true,
        content: 'Data accuracy and minimisation review date',
      },
    ],
  },
  {
    columns: [
      { content: 'Student Data' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Visa Refusal' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1 st March' },
    ],
  },
  {
    columns: [
      { content: 'Previous Student\nVisas' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Passport' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Academic History\n Certificate' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Academic History\n Transcript' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'English Test' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'ATAS Certificate' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Parental Consent' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'TB Test' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Company\nSponsorship\nDetails\nDocument' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Government\nSponsorship\nDetails Document' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Personal Bank\nLetter' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Bank Statement' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Parent Financial\nCommitment Letter' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Birth Certificate or\n Guardianship' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Parent Bank Letter' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Scholarship Details\nDocument' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Loan Details\nDocument' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
  {
    columns: [
      { content: 'Deposit receipt' },
      { content: 'Student' },
      { content: 'Consent' },
      { content: 'Administration' },
      {
        content: '- University Partner (CAS & Compliance Team)\n - Regulated visa and immigration solicitor / advisor',
      },
      { content: 'Current academic year + one year' },
      { content: '1st November\n& 1st March' },
    ],
  },
];
